/** Allow minor start/end ordering inconsistencies when classifying rows as complete. */
export const GANTT_COMPLETE_DATE_TOLERANCE_MS = 60_000;

/** True when start/end are both present and within the complete-date tolerance. */
export function isCompleteDateRange(startTime: number, endTime: number): boolean {
  return startTime <= endTime + GANTT_COMPLETE_DATE_TOLERANCE_MS;
}

/** Parse a row/chart date value; returns null when missing or not a finite timestamp. */
export function toValidTime(value: unknown): number | null {
  if (value == null || value === '') {
    return null;
  }
  const time = new Date(value as string | number).getTime();
  return Number.isFinite(time) ? time : null;
}
